module.exports = __webpack_public_path__ + "img/single-vel-btn.4ed3ccf5.png";